const WEB_WIDTH =
  typeof window !== 'undefined' ? window.innerWidth : 1280;

/** Web auth screens use CSS breakpoints — no useWindowDimensions subscription. */
export const useDeviceType = () => ({
  isTablet: WEB_WIDTH >= 600,
});
